import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRelatorioLotesVsEstoque {
  lastSetDefault: Date;

  DZ00DATA_DE: Date | undefined;
  DZ00DATA_ATE: Date | undefined;
  CZ02LOTE: string;
  CA1CODLOJA: string;
  CA1COD: string;
  CA1LOJA: string;
  CZ00COD: string;
  CB1COD: string;
  CTIPO: string;
}

export class FiltroRelatorioLotesVsEstoque {

  dados: IFiltroRelatorioLotesVsEstoque;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-relatorio-lotes-vs-estoque';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRelatorioLotesVsEstoque) => {
      if (filtro) {

        const {
          lastSetDefault,
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRelatorioLotesVsEstoque => {
    return {
      lastSetDefault: new Date(),
      DZ00DATA_DE: this.getData(-7),
      DZ00DATA_ATE: new Date(),
      CZ02LOTE: '',
      CA1CODLOJA: '',
      CA1COD: '',
      CA1LOJA: '',
      CZ00COD: '',
      CB1COD: '',
      CTIPO: 'E',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
